module.exports = __webpack_public_path__ + "static/img/拉通.db9f78c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/拉通.jpg
// module id = SnjZ
// module chunks = 1